import { Typography } from "@suraasa/placebo-ui"
import EmptyStateImage from "assets/Cpat/cpat_report_empty_state.webp"
import { useGlobalContext } from "global/Context/context"

export const NoCpatAllocatedState = () => {
  const { isNcte } = useGlobalContext()
  return (
    <div className="flex min-h-screen flex-col items-center justify-center sm:flex-row">
      <img src={EmptyStateImage} alt="" className="h-[174px]" />
      <div className="flex max-w-xs flex-col text-center md:text-left">
        <Typography variant="title3" className="mb-0.5 text-onSurface-600">
          Nothing to see here yet!
        </Typography>
        <Typography variant="smallBody" className="text-onSurface-500">
          The {!isNcte && "CPAT"} assessment is not available for your account
          at the moment.
        </Typography>
      </div>
    </div>
  )
}
